import React, { createRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Dropdown, Menu, Badge, message, Select, Form, Button } from 'antd';
import { UserOutlined, AppstoreOutlined, GlobalOutlined, ShoppingCartOutlined, FileTextOutlined, DownOutlined, ContainerOutlined } from '@ant-design/icons';
import emitter from '../util/emitter';
import send from '../util/request';
import CpChangePassword from '../components/CpChangePassword';
import { initShopCart } from '../store/actions/shopCartActions';
import { initPlanList } from '../store/actions/planListActions';
import { modify_local_language } from '../store/actions/languageActions';
import { keyToValue } from '../util/tool';
import { apiLog, commonCurrency, userJoinCompanys, userSwitchCompanys } from '../api';
import { STATIC_RESOURCE } from '../origin';
import './basicLayout.less';


const PathMapKeys = {
  home: '/basic/home',
  location: '/basic/location',
  shopCart: '/basic/shopCart',
  enquiryCart: '/basic/enquiryCart',
  user: '/basic/user',
  planList: '/basic/planList',
  quotation: '/basic/quotation'
};
const PATH2KEY = keyToValue(PathMapKeys);
const { localStorage } = window;

const current_config = {
  zh_shop_cart_title: '购物车',
  en_shop_cart_title: 'Cart',
  zh_plan_list_title: '计划清单',
  en_plan_list_title: 'List of Plans',
  zh_enquiry_cart_title: '询价单',
  en_enquiry_cart_title: 'Inquiry',
  zh_home_title: '全部商品',
  en_home_title: 'All Products',
  zh_user_title: '个人中心',
  en_user_title: 'Buyer Center',
  zh_logout_title: '退出登录',
  en_logout_title: 'Log out',
  zh_change_word_title: '修改密码',
  en_change_word_title: 'Change Password',
  zh_switch_company_title: '切换公司',
  en_switch_company_title: 'Switch Company',
  zh_language_title: '语言',
  en_language_title: 'Language',
  zh_currency_title: '币种',
  en_currency_title: 'Currency',
  zh_save_title: '保存',
  en_save_title: 'Save',
};

const language_list = [
  { zh_title: '简体中文', en_title: '简体中文', value: 'zh_' },
  { zh_title: 'English', en_title: 'English', value: 'en_' },
];

const layout_config = { zh_title: '简体中文', en_title: 'English', value: 'zh_' };

const title_config = {
  zh_title: '正大采购平台',
  en_title: 'CP Global Sourcing Platform',
};
const RMB_config = [
  { zh_title: 'CNY-人民币', en_title: 'CNY-RMB', value: 'RMB' },
  { zh_title: 'USD-美元', en_title: 'USD-US Dollar', value: 'USD' },
];

const relatedApplicationsItems_config = {
  zh_title_related_applications: '相关应用', en_title_related_applications: 'Related Applications',
  zh_title_cp_gsp_mini_program: 'CP采购平台小程序', en_title_cp_gsp_mini_program: 'CP GSP mini program',
  zh_title_cp_quality_inspection: '正大质检小程序', en_title_cp_quality_inspection: 'CP Quality Inspection',
};

let UN_LISTEN = () => { };

class BasicLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeMenuKey: '',
      language: 'zh_',
      companyList: [],
    };
    emitter.on('goHome', () => {
      this.setState({
        activeMenuKey: 'home'
      });
    });
    this.form = createRef();
  }

  async getUserJoinCompanys() {
    const { data: { data, code } } = await userJoinCompanys();
    if (+code === 0) {
      this.setState({ companyList: data.list });
    }
  }
  componentDidMount() {
    const token = localStorage.getItem('token');
    if (!token) {
      return ;
    }
    // return;
    this.getCommonCurrency();
    this.getUserJoinCompanys();
    const { initShopCart, initPlanList } = this.props;
    initShopCart();
    initPlanList();
    const uid = localStorage.getItem('user_id');
    if (!uid) {
      return this.logout();
    }
    apiLog({
      path: window.location.pathname,
      path_info: '',
      params: window.location.search,
      source: 2,
      uid
    });

    UN_LISTEN = this.props.history.listen((location, action) => {
      apiLog({
        path: location.pathname,
        path_info: '',
        params: location.search,
        source: 2,
        uid
      });
      // 在这里进行你的操作
    });
  }
  componentWillUnmount() {
    this.setState = () => false;
    UN_LISTEN && UN_LISTEN();
  }
  async getCommonCurrency() {
    // commonCurrency
    const { data: { data: { list = [] } } } = await commonCurrency();
    // this.setState({ currencyList: list });
    const currency_1 = localStorage.getItem('currency_1') || 'RMB';
    const currencyItem = list.find(item => item.currency_en === currency_1);
    localStorage.setItem('currencyItem', JSON.stringify(currencyItem));
  }

  static getDerivedStateFromProps(props) {
    let { pathname } = props.location;
    let pathNameArray = pathname.split('/');
    if (pathNameArray.length >= 3) {
      pathNameArray = pathNameArray.splice(0, 3);
      pathname = pathNameArray.join('/');
    }
    const { localeLanguage: { language } } = props;
    return { activeMenuKey: PATH2KEY[pathname], language };
  }
  onClickMenu = (e) => {
    const { key } = e;
    const { history } = this.props;
    this.setState({
      activeMenuKey: key,
    }, () => {
      if (key === 'user') {
        let { location: { pathname } } = this.props;
        let pathNameArray = pathname.split('/');
        if (pathNameArray.length >= 3) {
          pathNameArray = pathNameArray.splice(0, 3);
          pathname = pathNameArray.join('/');
        }
        if (pathname === PathMapKeys[key]) { return; }
      }
      history.push(PathMapKeys[key]);
    });
  };
  logout = () => {
    emitter.emit('logout');
    localStorage.clear();
    send({
      url: '/ipp/user/logout',
      method: 'GET',
    }).then((res) => {
      if (res.data && res.data.code === 0) {
        // localStorage.clear();
        localStorage.removeItem('token');
        localStorage.removeItem('userName');
        localStorage.removeItem('account');
        localStorage.removeItem('companyId');
        localStorage.removeItem('currencyItem');
        localStorage.removeItem('companyName');
        localStorage.removeItem('warehouse_type');
        localStorage.removeItem('user_id');
        localStorage.removeItem('group_type');
        emitter.emit('logout');
      } else {
        message.error(res.data.msg);
      }
    });
  };
  changePassword = () => {
    this.setState({
      pwdModalVisible: true,
    });
  };
  changeLanguage = () => {
    console.log(this.props, 'this.props');
  }

  hideModal = () => {
    this.setState({
      pwdModalVisible: false,
    });
  };
  submitModal = () => {
    this.setState({
      pwdModalVisible: false,
    });
    localStorage.clear();
    emitter.emit('logout');
  };

  save = (values = {}) => {
    const { language = 'zh_', currency_1 = 'zh_' } = values;
    // this.props.modify_local_language({ language });
    // const rmb_text = `CNY-${RMB_config[`${language}title`]}`;
    // this.form.setFieldsValue({ currency_1: rmb_text });
    // window.location.reload();
    localStorage.setItem('language', language);
    localStorage.setItem('currency_1', currency_1);
    window.location.reload();
  }

  async switchCompany(item) {
    const { data: { data, code } } = await userSwitchCompanys({ switch_company_id: item.id });
    if (+code === 0) {
      const { token, user_info: { company_id, username, account, id }, company_info: { company_name, warehouse_type, group_type } } = data;
      localStorage.setItem('token', token);
      localStorage.setItem('userName', `${company_name ? company_name : ''}(${username})`);
      localStorage.setItem('account', account);
      localStorage.setItem('companyId', company_id);
      localStorage.setItem('companyName', company_name);
      localStorage.setItem('warehouse_type', warehouse_type);
      localStorage.setItem('user_id', id);
      localStorage.setItem('group_type', group_type);
      localStorage.removeItem('select_rows_cache');
      window.location.href = '/basic/index';
    }
  }

  render() {
    const { activeMenuKey, pwdModalVisible, language, companyList } = this.state;
    const currency_1 = localStorage.getItem('currency_1') || 'RMB';
    const { productNum, planListNum } = this.props;

    const shopCartItems = [
      { label: <><span>{current_config[`${language}shop_cart_title`]}</span></>, key: 'shopCart', icon: <><ShoppingCartOutlined /><Badge count={productNum} overflowCount={99} style={{ backgroundColor: '#D60505' }}></Badge></> },
      { label: <><span>{current_config[`${language}plan_list_title`]}</span></>, key: 'planList', icon: <><FileTextOutlined /><Badge count={planListNum} overflowCount={99} style={{ backgroundColor: '#D60505', }}></Badge></> },
      { label: <><span>{current_config[`${language}enquiry_cart_title`]}</span></>, key: 'enquiryCart', icon: <ContainerOutlined /> },
    ];

    const switchCompanyItem = companyList.length === 0 ? undefined : {
      label: <div style={{ marginLeft: 5 }}>{current_config[`${language}switch_company_title`]}</div>, key: 'switch_company',
      children: companyList.map(item => ({ label: <div style={{ marginLeft: 5 }} onClick={() => this.switchCompany(item)}>{item.name}</div>, key: `${item.id}` }))
    };

    const userMenuItems = [
      switchCompanyItem,
      { label: <div onClick={this.changePassword} style={{ marginLeft: 5 }}>{current_config[`${language}change_word_title`]}</div>, key: 'change_word' },
      { label: <div style={{ marginLeft: 5 }} onClick={this.logout}>{current_config[`${language}logout_title`]}</div>, key: 'login' },
    ].filter(item => item);

    const items = [
      { label: <>{current_config[`${language}home_title`]}</>, icon: <AppstoreOutlined />, key: 'home' },
      { label: <>{current_config[`${language}user_title`]}</>, icon: <UserOutlined />, key: 'user' },
    ];

    const relatedApplicationsItems = [
      {
        key: '1',
        label: (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <img style={{ width: 62, height: 62, margin: 'auto' }} src={`${STATIC_RESOURCE}/cp_gsp/header/minilogo.png`} alt={relatedApplicationsItems_config[`${language}title_cp_gsp_mini_program`]} />
            <div style={{ marginTop: 6, }}>{relatedApplicationsItems_config[`${language}title_cp_gsp_mini_program`]}</div>
          </div>
        ),
      },
      {
        key: '2',
        label: (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <img style={{ width: 62, height: 62, margin: 'auto' }} src={`${STATIC_RESOURCE}/cp_gsp/home/CPQualityInspection.jpg`} alt={relatedApplicationsItems_config[`${language}title_cp_quality_inspection`]} />
            <div style={{ marginTop: 6, }}>{relatedApplicationsItems_config[`${language}title_cp_quality_inspection`]}</div>
          </div>
        ),
      },
    ];
    const userMenu = <Menu items={userMenuItems} expandIcon={<></>}></Menu>;
    const relatedApplicationsItemsMenu = <Menu items={relatedApplicationsItems}></Menu>;
    const company_name = localStorage.getItem('companyName');
    const account = localStorage.getItem('account');
    const rmb_text = `${currency_1}`;
    return (
      <div className="basic-layout">
        <div className="header">
          <div className="header-content">
            <div className="header-left" onClick={() => {
              const { pathname } = this.props.location;
              if (pathname !== '/basic/index') {
                this.props.history.push('/basic/index');
              }
            }}><div className="header-title">{title_config[`${language}title`]}</div></div>
            <div className="header-menu"><Menu onClick={this.onClickMenu} selectedKeys={[activeMenuKey]} style={{ border: '0px', height: 64, lineHeight: '66px' }} mode="horizontal" inlineIndent={20} items={items} /></div>
            <div className="header-right">
              <Menu onClick={this.onClickMenu} selectedKeys={[activeMenuKey]} style={{ border: '0px', height: 64, lineHeight: '66px', display: 'flex', justifyContent: 'flex-end' }} mode="horizontal" items={shopCartItems} />
            </div>
            <Dropdown
              dropdownRender={() => relatedApplicationsItemsMenu}
            >
              <div className='user-info'>
                <div>{relatedApplicationsItems_config[`${language}title_related_applications`]}</div>
                <DownOutlined />
              </div>
            </Dropdown>
            <Dropdown
              dropdownRender={() => {
                return <div style={{ padding: 10, background: '#fff', boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.23)' }}>
                  <Form
                    layout="vertical"
                    autoComplete="off"
                    ref={el => this.form = el}
                    initialValues={{ currency_1: rmb_text, language }}
                    onFinish={this.save}
                  >
                    <Form.Item label={current_config[`${language}language_title`]} name='language'>
                      <Select>{language_list.map(item => <Select.Option key={item.value} value={item.value}>{item[`${language}title`]}</Select.Option>)}</Select>
                    </Form.Item>
                    <Form.Item label={current_config[`${language}currency_title`]} name='currency_1'>
                      <Select>{RMB_config.map(item => <Select.Option key={item.value} value={item.value}>{item[`${language}title`]}</Select.Option>)}</Select>
                    </Form.Item>
                    <Form.Item>
                      <Button block type="primary" htmlType="submit">{current_config[`${language}save_title`]}</Button>
                    </Form.Item>
                  </Form>
                </div>;
              }}
            >
              <div className='user-info' >
                <div><GlobalOutlined style={{ marginRight: 10 }} />{layout_config[`${language}title`]} - CNY</div>
                <DownOutlined />
              </div>
            </Dropdown>
            <Dropdown dropdownRender={() => userMenu}>
              <div className='user-info' >
                <div>
                  <div style={{ maxWidth: 240, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{company_name}</div>
                  <div>{account ? `${account}` : null}</div>
                </div>
                <DownOutlined />
              </div>
            </Dropdown>
          </div>
        </div >
        <div className="header-shadow"></div>
        <div className="content">{this.props.children}</div>
        {pwdModalVisible && (<CpChangePassword hideModal={this.hideModal} submitModal={this.submitModal} />)}
      </div >
    );
  }
}
const mapStateToProps = (state) => {
  const { shopCart, planList, localeLanguage } = state;
  const { cartIds } = shopCart;
  const productNum = cartIds.length;
  const { cartIds: planListIds } = planList;
  const planListNum = planListIds.length;
  return { productNum, planListNum, localeLanguage };
};
const mapDispatchToProps = (dispatch) => {
  return {
    initShopCart: () => { dispatch(initShopCart()); },
    initPlanList: () => { dispatch(initPlanList()); },
    modify_local_language: (value) => { dispatch(modify_local_language(value)); },
  };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BasicLayout));
